var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
  var len = len - (s + '').length;
  for (var i = 0; i < len; i++) {
    s = '0' + s;
  }
  return s;
};

export default {
  getQueryStringByName: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    var context = "";
    if (r != null)
      context = r[2];
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
  },
  formatDate: {
    format: function (date, pattern) {
      pattern = pattern || DEFAULT_PATTERN;
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y':
          return padding(date.getFullYear(), $0.length);
          case 'M':
          return padding(date.getMonth() + 1, $0.length);
          case 'd':
          return padding(date.getDate(), $0.length);
          case 'w':
          return date.getDay() + 1;
          case 'h':
          return padding(date.getHours(), $0.length);
          case 'm':
          return padding(date.getMinutes(), $0.length);
          case 's':
          return padding(date.getSeconds(), $0.length);
        }
      });
    },
    parse: function (dateString, pattern) {
      var matchs1 = pattern.match(SIGN_REGEXP);
      var matchs2 = dateString.match(/(\d)+/g);
      if (matchs1.length == matchs2.length) {
        var _date = new Date(1970, 0, 1);
        for (var i = 0; i < matchs1.length; i++) {
          var _int = parseInt(matchs2[i]);
          var sign = matchs1[i];
          switch (sign.charAt(0)) {
            case 'y':
            _date.setFullYear(_int);
            break;
            case 'M':
            _date.setMonth(_int - 1);
            break;
            case 'd':
            _date.setDate(_int);
            break;
            case 'h':
            _date.setHours(_int);
            break;
            case 'm':
            _date.setMinutes(_int);
            break;
            case 's':
            _date.setSeconds(_int);
            break;
          }
        }
        return _date;
      }
      return null;
    }

  }, getObjectClass(obj) {
    if (obj && obj.constructor && obj.constructor.toString()) {
      /*
       * for browsers which have name property in the constructor
       * of the object,such as chrome
       */
       if (obj.constructor.name) {
        return obj.constructor.name;
      }
      var str = obj.constructor.toString();
      /*
       * executed if the return of object.constructor.toString() is
       * "[object objectClass]"
       */
       if (str.charAt(0) == '[') {
        var arr = str.match(/\[\w+\s*(\w+)\]/);
      } else {
        /*
         * executed if the return of object.constructor.toString() is
         * "function objectClass () {}"
         * for IE Firefox
         */
         var arr = str.match(/function\s*(\w+)/);
       }
       if (arr && arr.length == 2) {
        return arr[1];
      }
    }
    return undefined;
  },formatOrderStatus (status) {
    return status == "DRAFT" ? '草稿' :status=="RECEIVED"?'已确认' : status == "DISPATCHING" ? '调度中' :status=="DISPATCHED"?'调度完成' :status=="ALLOCATING"?'分库调度中' :status=="ALLOCATED"?'分库调度完成':status=="SHIPPING"?'配送中':status=="SHIPPED"?'配送完成': '未知';
  },reverseFormatOrderStatus (status) {
    return status == "草稿" ? 'DRAFT' :status=="已确认"?'RECEIVED' : status == "调度中" ? 'DISPATCHING' :status=="调度完成"?'DISPATCHED' :status=="分库调度中"?'ALLOCATING' :status=="分库调度完成"?'ALLOCATED':status=="配送中"?'SHIPPING':status=="配送完成"?'SHIPPED': '未知';
  }

};



// WEBPACK FOOTER //
// ./src/common/js/util.js